<template>
  <div class="tree-node">
    <!-- Controlla se il nodo è un placeholder -->
    <div v-if="!node.isPlaceholder">
      <input type="checkbox" :value="node.CODICE" :checked="localSelectedCodes.includes(node.CODICE)"
        @change="toggleSelection" />
      <span :class="{ 'first-level': isFirstLevel }">{{ node.DESCRIZIONE || "Ateco senza descrizione" }}</span>
    </div>
    <div v-else>
      <span class="placeholder-node"><!--Nodo padre mancante--></span>
    </div>

    <!-- Renderizza i figli ricorsivamente -->
    <div :class="{ children: !node.isPlaceholder }" v-if="node.children && node.children.length > 0">
      <TreeNode v-for="child in node.children" :key="child.CODICE" :node="child" :selectedCodes="localSelectedCodes"
        @update-selection="updateSelection" :isChild="true" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeNode",
  props: {
    node: {
      type: Object,
      required: true,
    },
    selectedCodes: {
      type: Array,
      required: true,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isFirstLevel() {
      return !this.isChild && (!this.node.CODICE_PADRE || this.node.CODICE_PADRE === this.node.CODICE);
    },
  },
  data() {
    return {
      localSelectedCodes: [...this.selectedCodes], // Copia iniziale dello stato
    };
  },
  watch: {
    // Sincronizza lo stato locale quando la prop cambia
    selectedCodes(newVal) {
      this.localSelectedCodes = [...newVal];
    },
  },
  methods: {
    toggleSelection(event) {
      const code = this.node.CODICE;

      if (event.target.checked) {
        // Aggiungi il codice se selezionato
        if (!this.localSelectedCodes.includes(code)) {
          this.localSelectedCodes.push(code);
        }
      } else {
        // Rimuovi il codice se deselezionato
        this.localSelectedCodes = this.localSelectedCodes.filter((c) => c !== code);
      }
      // Emetti l'evento per notificare il genitore
      this.$emit("update-selection", this.localSelectedCodes);
    },
    updateSelection(selectedCodes) {
      // Propaga l'evento al genitore
      this.$emit("update-selection", selectedCodes);
    },
  },
};
</script>

<style scoped>
.tree-node {
  margin-left: 10px;
}

.placeholder-node {
  color: gray;
  font-style: italic;
}

.children {
  margin-left: 20px;
}

.first-level {
  font-weight: bold;
}

/* Stile per aumentare la dimensione dei checkbox */
.tree-node input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
}
</style>